var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-meeting-room-wrap",class:_vm.minimized ? 'minimized' : ''},[_c('div',{staticClass:"floating-meeting-room"},[(!_vm.minimized)?_c('v-icon',{staticClass:"close-icon",attrs:{"color":"icon","size":"medium"},on:{"click":_vm.onClose}},[_vm._v(" mdi-close")]):_vm._e(),_c('MeetingVideoRoom')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }